import Tr from 'translations/Translations';

export const OfferChoiceDecision = {
    NONE: "NONE",
    OFFER_CHOSEN: "OFFER_CHOSEN",
    CANCELED: "CANCELED"
}
const _TR_PREFIX = 'offer_choice_decision_';

export const OfferChoiceDecisionLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));
